import qs from 'qs';
import client from './client';
import { config } from '../../config';

export const whUuid = config.DEFAULT_WH_UUID;
const inventoryUrl = '/api/v1/master/wh';

// ========== 창고 마스터 CRUD ==========

//창고 목록
export const getWarehouseList = (params) => {
    const queryString = qs.stringify(params);
    return client.get(`${inventoryUrl}/list?${queryString}`);
};

//창고 상세
export const getWarehouseInfo = (whUuid) => {
    return client.get(`${inventoryUrl}/master/${whUuid}`);
};

//기본 창고 조회
export const getDefaultWarehouse = () => {
    return client.get(`${inventoryUrl}/default`);
};

//창고 등록
export const addWarehouse = (dataToSubmit) => {
    return client.post(`${inventoryUrl}/master`, dataToSubmit);
};

//창고 수정
export const editWarehouse = (whUuid, dataToSubmit) => {
    return client.put(`${inventoryUrl}/master/${whUuid}`, dataToSubmit);
};

//창고 삭제
export const removeWarehouse = (whUuid) => {
    return client.delete(`${inventoryUrl}/master/${whUuid}`);
};

// ========== 재고 관리 ==========

//재고 리스트
export const getInventoryStocks = (whId, params) => {
    const queryString = qs.stringify(params);
    return client.get(`${inventoryUrl}/${whId}/list?${queryString}`);
};

//재고 이력 리스트
export const getInventoryHistory = (whId, params) => {
    const queryString = qs.stringify(params);
    return client.get(`${inventoryUrl}/${whId}/info?${queryString}`);
};

//재고 상세 보기
export const getTranInfo = (whId, id) => {
    return client.get(`${inventoryUrl}/${whId}/info/${id}`);
};

//입고/출고 등록
export const addStockInfo = (dataToSubmit) => {
    return client.post(`${inventoryUrl}/info`, dataToSubmit);
};

//입출고 취소
export const delTransInfo = (whId, id) => {
    return client.delete(`${inventoryUrl}/${whId}/info/${id}`);
};

//재고 수정 (수량/단가)
export const editStockInfo = (whId, stockUuid, dataToSubmit) => {
    return client.put(`${inventoryUrl}/${whId}/stock/${stockUuid}`, dataToSubmit);
};

//창고간 재고 이동
export const moveStockInfo = (dataToSubmit) => {
    return client.post(`${inventoryUrl}/move`, dataToSubmit);
};
